import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const singlePUblisherAction = createAsyncThunk(
    'single-publisher',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/single-publisher-data-from-publisher-model?publisherId=${data?.publisherId}`) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const SinglePublisherSlice = createSlice({
    name: 'single-publishe',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(singlePUblisherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(singlePUblisherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(singlePUblisherAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const singlePublisherReducer = SinglePublisherSlice.reducer